import React, { FC } from 'react';
import { Breakpoint } from '@altibox/design-system-component-lib';

import { StyledLabel, StyledTotalPriceRow, StyledTotalPrices, StyledValue } from './total-prices.styled';

interface TotalPrice {
    label: string;
    value: string;
}

export interface TotalPricesProps {
    totalPrices?: TotalPrice[];
}

export const TotalPrices: FC<TotalPricesProps> = (props) => {
    const { totalPrices } = props;

    if (!totalPrices || !totalPrices.length) {
        return null;
    }

    return (
        <StyledTotalPrices>
            {totalPrices.map((totalPrice, index) => (
                <StyledTotalPriceRow key={index}>
                    <StyledLabel component="p" variant="paragraph2" maxBreakpoint={Breakpoint.TABLET}>
                        {totalPrice.label}
                    </StyledLabel>
                    <StyledValue component="p" variant="paragraph2" maxBreakpoint={Breakpoint.TABLET}>
                        {totalPrice.value}
                    </StyledValue>
                </StyledTotalPriceRow>
            ))}
        </StyledTotalPrices>
    );
};
